import { render } from "./PaymentsIndex.vue?vue&type=template&id=a10ead88&scoped=true"
import script from "./PaymentsIndex.vue?vue&type=script&lang=js"
export * from "./PaymentsIndex.vue?vue&type=script&lang=js"

import "./PaymentsIndex.vue?vue&type=style&index=0&id=a10ead88&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a10ead88"]])

export default __exports__